import React, {useEffect, useState} from "react";
import {cloneDeep} from "lodash";
import {arrayIncludeItem} from "@app/utils/CommonUtils";
import Select from "react-select";
import {SavedListTabOptions} from "@pages/savedlist/common/Constant";
import {requestGetJobList, requestStartRunJob} from "@app/services/JobService";
import {requestGetUserEmailList} from "@app/services/UserService";
import * as CandidateService from "@app/services/CandidateService";
import {toast} from "react-toastify";
import {ResponseCode} from "@app/constants/Common";
import {alertMessage} from "@app/constants/Messages";
import {ProcessJobInternalProcessOptions} from "@pages/jobpipeline/common/Constant";

const RunJobBasicInfo = (props) => {
    const [isStarting, setStarting] = useState(false);
    const [selectJob, setSelectJob] = useState({});
    const [selectInternalProcess, setSelectInternalProcess] = useState({});
    const [runJobInfo, setRunJobInfo] = useState({});
    const [selectJobOptions, setSelectJobOptions] = useState([]);

    const {runJob, onStart} = props

    const fetchJobList = async () => {
        const res = await requestGetJobList({unlimited: true});
        const jobOptionList = res.content.jobs.map((item) => {
            if (runJob && item.id === runJob.job_id) {
                setSelectJob({value: item.id, label : item.job_name})
            }
            return  {value: item.id, label : item.job_name}
        });
        setSelectJobOptions(jobOptionList);
    }

    const onSelectJob = (jobOption) => {
        setSelectJob(jobOption)
        // runJobInfo.job_id=jobOption.value
    }

    const onSelectInternalProcess = (values) => {
        setSelectInternalProcess(values)
    }

    useEffect(() => {
        if (runJob) {
            setRunJobInfo({...runJob})
        }
    },[runJob]);

    useEffect(() => {
        fetchJobList()
    },[]);

    const onStartToRunJob = async () => {
        if (!selectJob.value) {
            alert("Vui lòng chọn 1 job.")
            return;
        }

        setStarting(true)
        const res = await requestStartRunJob({
            candidate_ids: runJobInfo.candidate_ids,
            job_id: selectJob.value,
            internal_process: selectInternalProcess.value
        });
        setStarting(false)

        if (res.sts_code !== ResponseCode.SUCCESS) {
            alertMessage(res.sts_code, false, true)
        } else {
            setRunJobInfo(res.content)
            onStart(res.content)
        }
    }

    return (
        <div className="card card-default">
            <div className="card-header">
                <h3 className="card-title text-bold">Run job basic info</h3>
                <button type="button" className="btn btn-tool" data-card-widget="collapse">
                    <i className="fas fa-minus"/>
                </button>
            </div>
            <div className="card-body">
                {runJobInfo.job_id &&
                <label className={'w-100'}>Job ID: {runJobInfo.job_id}</label>
                }
                {!runJobInfo.job_id &&
                <div className={"row"}>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Chọn job</label>
                            <Select options={selectJobOptions}
                                    placeholder={"Chọn job"}
                                    value={selectJob}
                                    isDisabled={runJobInfo.id && runJobInfo.job_id}
                                    onChange={values => {
                                        onSelectJob(values);
                                    }}
                            />
                        </div>
                    </div>
                    <div className='col-sm-6'>
                        <div className='form-group'>
                            <label className={'w-100'}>Process nội bộ</label>
                            <Select options={ProcessJobInternalProcessOptions}
                                    placeholder={"Process nội bộ"}
                                    value={selectInternalProcess}
                                    onChange={values => {
                                        onSelectInternalProcess(values);
                                    }}
                            />
                        </div>
                    </div>
                </div>
                }
                {!runJob.id &&
                <div className={''}>
                    <button
                        type='button'
                        className='btn btn-primary mt-2'
                        onClick={() => onStartToRunJob()}
                        disabled={isStarting || (runJob.id && runJob.job_id)}
                    >
                        {isStarting ? "Processing..." : "Start"}
                    </button>
                </div>
                }
            </div>
        </div>
    )
}

export default RunJobBasicInfo;
